<template>
  <!--	노션 링크 : https://www.notion.so/IntroducePage-ddc5cbce23cc436b8829d2627156fb40 -->
  <div>
    <div>
      <breadcrumb :breadcrumb_link="presidentialsweet_breadcrumb" />
    </div>

    <div class="header">
      <h1 class="overlay">ROOMS</h1>
      <!--      <img src="@/assets/images/Podohotel/room_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container contentDesc">
      <div :class="{jpword: isLang === 2}">
        <div :class="{anotherword: isLang === 0 || isLang === 1}">
          <div class="title1">
            <h2>
              <strong>{{ $t('presidential_title') }}</strong>
            </h2>
          </div>
          <div class="title2">
            <h4>{{ $t('presidential_subtitle') }}</h4>
          </div>
          <div class="title3">
            <p v-html="$t('presidential_desc')"></p>
          </div>
        </div>
        <div class="container">
          <GallerySlideCarousels :slides="slides" :slide-count="4" :thumb-slide-width="50" />

          <div class="text-center pt-5 pb-5">
            <h1>{{ $t('presidential_feature_title') }}</h1>
          </div>

          <div class="row no-gutters" style="background-color: #f5f5f5">
            <div class="col-lg-6 col-12" align="center">
              <img src="@/assets/images/Podohotel/presidentialsweet_room_feature01.jpg" style="width: 100%" />
            </div>
            <div class="col-lg-6 col-12 my-lg-auto mt-5 mb-5 pl-3 pr-3">
              <h4>{{ $t('presidential_feature_subtitle1') }}</h4>
              <br />
              <p>{{ $t('presidential_feature_desc1') }}</p>
            </div>
          </div>

          <div class="row no-gutters" style="background-color: #f5f5f5">
            <div class="col-lg-6 col-12 order-lg-0 order-1 my-lg-auto mt-5 mb-5 pl-3 pr-3 text-right">
              <h4>{{ $t('presidential_feature_subtitle2') }}</h4>
              <br />
              <p>{{ $t('presidential_feature_desc2') }}</p>
            </div>
            <div class="col-lg-6 col-12 order-lg-1 order-0" align="center">
              <img src="@/assets/images/Podohotel/presidentialsweet_room_feature02.jpg" style="width: 100%" />
            </div>
          </div>

          <div class="row no-gutters" style="background-color: #f5f5f5">
            <div class="col-lg-6 col-12" align="center">
              <img src="@/assets/images/Podohotel/presidentialsweet_room_feature03.jpg" style="width: 100%" />
            </div>
            <div class="col-lg-6 col-12 my-lg-auto mt-5 mb-5 pl-3 pr-3">
              <h4>{{ $t('presidential_feature_subtitle3') }}</h4>
              <br />
              <p>{{ $t('presidential_feature_desc3') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <Amenity_Presidentialsweet />
    </div>

    <div class="offersStyle" v-show="isLang === 0">
      <SpecialOffers />
    </div>
  </div>
</template>

<script>
import GallerySlideCarousels from '@/components/GallerySlideCarousels';
import Breadcrumb from '@/components/Breadcrumb';
import SpecialOffers from '@/pages/MainPage/Components/SpecialOffers';
import Amenity_Presidentialsweet from '@/pages/Room/Components/Amenity_Presidentialsweet';

export default {
  name: 'Presidentialsweet',
  data() {
    return {
      presidentialsweet_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'ROOM',
        present: this.$t('breadcrumb'),
      },
      slides: [
        {image: require('@/assets/images/Podohotel/presidentialsweet_room_image01.jpg')},
        {image: require('@/assets/images/Podohotel/presidentialsweet_room_image02.jpg')},
        {image: require('@/assets/images/Podohotel/presidentialsweet_room_image03.jpg')},
        {image: require('@/assets/images/Podohotel/presidentialsweet_room_image04.jpg')},
        {image: require('@/assets/images/Podohotel/presidentialsweet_room_image05.jpg')},
        {image: require('@/assets/images/Podohotel/presidentialsweet_room_image06.jpg')},
        {image: require('@/assets/images/Podohotel/presidentialsweet_room_image07.jpg')},
      ],
      index: 0, // default: 0,
      isLang: 0,
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.presidentialsweet_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'ROOM',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  components: {Amenity_Presidentialsweet, GallerySlideCarousels, Breadcrumb, SpecialOffers},
};
</script>

<style scoped lang="scss">
.jpword {
  word-break: break-all;
}
.anotherword {
  p,
  h4 {
    word-break: keep-all;
  }
}
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}

.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}
@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/Podohotel/room_headerimage.jpg');
  }
}

@media (max-width: 992px) {
  .headerimage {
  }

  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }
}

.container {
  padding: 0;
}
.offersStyle {
  background-color: #eeeeee;
  padding-bottom: 3rem;
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "프레지덴셜 스위트",
    "presidential_title": "프레지덴셜 스위트",
    "presidential_subtitle": "포도호텔에서 만나는 또 하나의 호텔",
    "presidential_desc": "포도호텔만의 독보적인 감성과 최상의 Wellness를<br/>모두 경험할 수 있는 프레지덴셜 스위트룸은<br/>개인 스파존부터 야외 수영장, 파티를 즐길 수 있는 프라이빗 가든까지<br/>고품격 휴식과 힐링을 경험할 수 있는 가장 이상적인 공간입니다.",
    "presidential_feature_title": "객실 특징",
    "presidential_feature_subtitle1": "Prestige 고객을 위한 품격이 있는 공간, 리빙룸",
    "presidential_feature_desc1": "럭셔리한 인테리어가 돋보이는 거실 공간은 높은 층고와 전면 통창으로 이루어져 있어 여유로운 공간감을 느낄 수 있습니다. 최고급 사운드 B&O Beolab오디오와 대형 TV가 휴식의 품격을 더하며, 거실 중앙에는 만찬 또는 Bar로 이용할 수 있는 원 테이블이 비치되어 격조 높은 휴식을 제공합니다.",
    "presidential_feature_subtitle2": "이국적인 감성의 프라이빗 가든",
    "presidential_feature_desc2": "포도호텔의 단 하나뿐인 프라이빗 가든에는 전용 야외 수영장과 야외 BBQ를 즐길 수 있는 아웃도어 키친 등으로 이루어져 있어 낮에는 여유로운 휴식을, 밤에는 이국적인 가든 파티를 연출할 수 있는 가장 이상적인 휴식 공간입니다.",
    "presidential_feature_subtitle3": "아늑한 휴식을 위한 공간, 멀티룸",
    "presidential_feature_desc3": "다채로운 휴식과 비즈니스 업무를 위한 단독 공간인 멀티룸은 아담한 시크릿 가든의 자연 풍경과 좌식 온돌로 구성된 내부 공간으로 이루어져 아늑하고 격식있는 분위기를 제공합니다. 또한 티비와 게이밍 데스크탑이 비치되어 있어 안락한 휴식과 엔터테인먼트를 즐길 수 있는 최적의 공간입니다."
  },
  "en": {
    "breadcrumb": "Presidential suite",
    "presidential_title": "Presidential suite",
    "presidential_subtitle": "Meeting another hotel at the PODO Hotel.",
    "presidential_desc": "The Presidential Suite offers the unique vibe and exquisite wellness of the PODO Hotel.<br/>These luxurious suites feature a private spa pool, a outdoor pool and<br/>private garden with a high level of relaxation and healing.",
    "presidential_feature_title": "Room Features",
    "presidential_feature_subtitle1": "A classy space for Prestige customers, a living room",
    "presidential_feature_desc1": "The living space with a luxurious interior is made up of high ceilings and front windows, so you can feel a sense of spaciousness. High-end sound B&O Beolab audio and large TV add to the elegance of relaxation, and in the center of the living room, there is a one-table that can be used as a dinner or a bar, providing a dignified rest.",
    "presidential_feature_subtitle2": "Exotic private garden",
    "presidential_feature_desc2": "Podo Hotel's only private garden is composed of a private outdoor swimming pool and an outdoor kitchen where you can enjoy outdoor BBQ, making it the ideal resting space for a relaxing break during the day and an exotic garden party at night.",
    "presidential_feature_subtitle3": "A space for cozy relaxation, multi-room",
    "presidential_feature_desc3": "Multi-room, an exclusive space for various relaxation and business work, provides a cozy and formal atmosphere with the natural scenery of a small secret garden and an interior space composed of ondol. It is also equipped with a TV and gaming desktop, making it the perfect place to relax and enjoy entertainment."
  },
  "ja": {
    "breadcrumb": "プレジデンシャル スイートルーム",
    "presidential_title": "プレジデンシャル スイートルーム",
    "presidential_subtitle": "PODOホテルの中でホテル",
    "presidential_desc": "PODOホテルのみの 特別な感性と最高のWellnessを<br/>経験することができるプレジデンシャルスイートルームは、<br/>專用スパジョンから、屋外プール、<br/>パーティーを楽しむことができるプライベートガーデンまで<br/>最高の休息とヒーリングを体験できる理想的な空間です。",
    "presidential_feature_title": "客室の特長",
    "presidential_feature_subtitle1": "Prestige顧客のための品格のあるスペース、リビングルーム",
    "presidential_feature_desc1": "ラグジュアリーなインテリアが目を引くリビングスペースは、高い階高と前面ガラス張りで構成されており、ゆったりとした空間感を感じることができます。 最高級サウンドB&OBeolabオーディオと大型テレビが休息の品格を高め、リビングルームの中央には晩餐またはBarとして利用できるワンテーブルが備えられ、格調高い休息を提供します。",
    "presidential_feature_subtitle2": "エキゾチックな感性のプライベートガーデン",
    "presidential_feature_desc2": "ブドウホテルのたった一つのプライベートガーデンには、専用の屋外プールと屋外BBQが楽しめるアウトドアキッチンなどで構成されており、昼間はゆったりとくつろぎ、夜は異国的なガーデンパーティーを演出できる理想的な憩いの場です。",
    "presidential_feature_subtitle3": "居心地の良い休息のための空間、マルチルーム",
    "presidential_feature_desc3": "多彩な休息とビジネス業務のための単独空間であるマルチルームは、こじんまりとしたシークレットガーデンの自然風景と座敷オンドルで構成された内部空間で構成され、落ち着いた格式ある雰囲気を提供しています。 また、テレビとゲーミングデスクトップが備えられており、リラックスした休息とエンターテインメントを楽しむことができる最適な空間です。"
  }
}
</i18n>
